// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bHQTb{background:#fff;border-radius:10px;padding:1.2rem}", ""]);
// Exports
exports.locals = {
	"formContainer": "bHQTb"
};
module.exports = exports;
